export default {
  route: {
    home: '首页',
    product: '产品介绍',
    news: '新闻中心',
    application: '行业应用',
    company: '关于公司',
    employ: '招贤纳士',
    contactUs: '联系我们',
    postRecruitment: '岗位招聘',
  },
  footer:{
    contactUs: "联系我们",
    telephone: "电话",
    email: "邮箱",
    address: "地址",
    link: "友情链接",
    focusUs: "关注我们",
  },
  home:{
    managerMsg: "总经理寄语",
    aboutUs: "关于我们",
    productIntrudiction: "产品介绍",
    industryApplication: "应用场景",
    newsCenter: "新闻中心",
    companyNews: "公司新闻",
    industryNews: "行业新闻",
  },
  product: {
    param: "参数",
    radius: "作战半径",
    altitude: "巡飞高度",
    speed: "最大速度",
    emptyTime: "滞空时间",
    overload: "最大过载",
    resistance: "抗风能力",
    weight: "飞行重量",
    taskLoad: "任务载荷",
    mode: "导航方式",
    accuracy: "攻击精度",
    rate: "命中率",
    task: "任务目标",
    level: "级",
  },
  common: {
    pre: "上一页",
    next: "下一页",
    cancel: "取 消",
    delivery: "投 递",
  },
  news: {
    allNews: "全部新闻",
    companyNews: "公司新闻",
    industryNews: "行业新闻",
    detail: "了解详情",
  },
  industry: {
    platformProfile: "平台简介",
    platformAdvantages: "平台优点",
    industryApplication: "应用场景",
    industryAdvantages: "行业优势",
    publicSafety: "公共安全",
    patrol: "巡查",
    fireFighting: "应急消防",
  },
  company: {
    companyProfile: "公司简介",
    advantage: "研发优势",
    workshop: "科研生产部车间简介",
    employee: "专家顾问及团队介绍",
    culture: "企业文化",
    vision: "公司愿景",
    process: "发展历程",
    honor: "资质荣誉",
  },
  employ: {
    jobDesc: "职位描述",
    joinUs: "加入我们",
    qualifications: "任职资格",
    resumeDelivery: "简历投递",
    post: "岗位",
    name: "姓名",
    birthDate: "出生年月",
    selectBirthDate: "请选择出生年月",
    gender: "性别",
    selectGender: "请选择性别",
    male: "男",
    female: "女",
    enterName: "请输入姓名",
    contact: "联系方式",
    enterContact: "请输入联系方式",
    uploadResume: "上传简历",
    drag: "将文件拖到此处，或",
    clickUpload: "点击上传",

    contactUs: "联系我们",
    address: "公司地址",
    contactPhone: "联系电话",
    marketSales: "市场销售",
    weChatPublic: "微信公众号",
    onlinemessage: "在线留言",
    name: "姓名",
    contact: "联系方式",
    companyAddress: "公司地址",
    email: "邮箱",
    demand: "需求",
    message: "留言",
  },
}
